document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-bg-link');
  elements.forEach((target) => {
    target.addEventListener('mouseenter', () => {
      target.classList.add('hovered');
      target.classList.remove('leaving');
    });
    target.addEventListener('mouseleave', () => {
      target.classList.remove('hovered');
      target.classList.add('leaving');
      setTimeout(() => {
        target.classList.remove('leaving');
        target.classList.add('resetting');
        setTimeout(() => {
          target.classList.remove('resetting');
        }, 300);
      }, 300);
    });
  })
});
